import * as WebBrowser from "expo-web-browser";
import tw from "twrnc";
import React from "react";
import { View } from "react-native";
import AppConfig from "../../AppConfig";
import Text from "@/components/shared/AppText";
import { tRich } from "@/localization";

export const SignUpPrivacy = ({}) => {
  const openLink = async (url) => {
    await WebBrowser.openBrowserAsync(url);
  };

  const openTermsUrl = () => {
    openLink(AppConfig.TERMS_URL);
  };
  const openPrivacyUrl = () => {
    openLink(AppConfig.PRIVACY_URL);
  };

  return (
    <View style={tw`mt-[15px] mb-[10px] flex-row justify-center`}>
      <Text style={tw`text-xs text-center`}>
        {tRich(
          "By continuing you agree to our <privacy>privacy policy</privacy> and <terms>terms</terms>",
          {
            privacy: (words) => (
              <Text
                style={tw`text-xs text-center font-bold`}
                accessibilityRole="link"
                onPress={openPrivacyUrl}
              >
                {words}
              </Text>
            ),
            terms: (words) => (
              <Text
                style={tw`text-xs text-center font-bold`}
                accessibilityRole="link"
                onPress={openTermsUrl}
              >
                {words}
              </Text>
            ),
          }
        )}
      </Text>
    </View>
  );
};
